import { all } from 'redux-saga/effects'
import watchInterviewRequestDetailsChannel from './channels/interviewRequestDetails'
import watchInterviewRequestListChannel from './channels/interviewRequestList'
import watchInterviewRequestDetailsSaga from './interviewRequestDetails'
import watchInterviewRequestListSaga from './interviewRequestList'

export default function* rootSaga() {
  yield all([
    watchInterviewRequestDetailsChannel(),
    watchInterviewRequestListChannel(),
    watchInterviewRequestDetailsSaga(),
    watchInterviewRequestListSaga(),
  ])
}
